import { getPaymentTitle } from './getPaymentTitle';

export const EDITABLE_FIELD = {
    AMOUNT: 'AMOUNT',
    TITLE: 'TITLE',
};

export const getFields = (selectedRefund, editedAmount, editedReason) => {
    return [
        {
            label: 'Name:',
            value: `${selectedRefund?.consultant?.name} ${selectedRefund?.consultant?.surname}`,
        },
        {
            label: 'Amount:',
            value: editedAmount,
            editable: EDITABLE_FIELD.AMOUNT,
        },
        {
            label: 'Bank account number:',
            value: selectedRefund?.consultant?.bank_account_number,
        },
        {
            label: 'Title:',
            value: editedReason?.value ? getPaymentTitle(editedReason.value) : null,
            editable: EDITABLE_FIELD.TITLE,
        },
    ];
};
